'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _WishlistButton = require('./WishlistButton.scss');

var _WishlistButton2 = _interopRequireDefault(_WishlistButton);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _session = require('redux/modules/session');

var _wishlist = require('redux/modules/wishlist');

var wishlistActions = _interopRequireWildcard(_wishlist);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  WishlistButton: {
    displayName: 'WishlistButton'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/General/Buttons/WishlistButton.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

// import ApiClient from 'helpers/ApiClient';
// const client = new ApiClient();

var WishlistButton = _wrapComponent('WishlistButton')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    isLoggedIn: state.session.isLoggedIn
  };
}, (0, _extends3.default)({ openLoginSignup: _session.openLoginSignup, setLoginSignupCallback: _session.setLoginSignupCallback }, wishlistActions)), _dec2 = (0, _reactCssModules2.default)(_WishlistButton2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(WishlistButton, _Component);

  function WishlistButton(props) {
    (0, _classCallCheck3.default)(this, WishlistButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (WishlistButton.__proto__ || (0, _getPrototypeOf2.default)(WishlistButton)).call(this, props));

    _this.activeWishlist = function () {
      var _this$props = _this.props,
          tripId = _this$props.tripId,
          active = _this$props.active;

      _this.props.openLoginSignup(false);

      if (active) {
        _this.props.setWishlistButton(tripId, true);
        _this.props.removeWishlist(tripId).then(function () {
          return _this.props.loadWishlists();
        });
        // client.del(`trips/slug/${tripSlug}/wishlist`)
        /*
        .catch(() => {
          this.setState({active: true});
        });
        */
      } else {
        _this.props.setWishlistButton(tripId, false);
        _this.props.addWishlist(tripId).then(function () {
          return _this.props.loadWishlists();
        });
        // client.post(`trips/slug/${tripSlug}/wishlist`)
        /*
        .catch(() => {
          this.setState({active: false});
        });
        */
      }
    };

    _this.handleClick = function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (_this.props.isLoggedIn) {
        _this.activeWishlist();
      } else {
        _this.props.openLoginSignup();
        _this.props.setLoginSignupCallback(_this.activeWishlist);
        // this.props.setLoginSignupCallback(this.props.setWishlistButton(this.props.tripId, false));
      }
      // const {tripSlug} = this.props;
      // const {active} = this.state;

      // if (active) {
      //   client.del(`trips/slug/${tripSlug}/wishlist`).then(() => {
      //     this.setState({active: false});
      //   })
      //   .catch(() => {
      //     this.setState({active: true});
      //   });
      // } else {
      //   client.post(`trips/slug/${tripSlug}/wishlist`).then(() => {
      //     this.setState({active: true});
      //   })
      //   .catch(() => {
      //     this.setState({active: false});
      //   });
      // }
    };

    _this.renderLabel = function () {
      var _this$props2 = _this.props,
          label = _this$props2.label,
          active = _this$props2.active;

      var data = void 0;
      if (label) {
        data = _react3.default.createElement(
          'span',
          { styleName: 'mobile-hide-label' },
          active ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.remove_wishlist' }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.add_wishlist' })
        );
      }
      return data;
    };

    _this.state = {
      active: props.active
    };
    return _this;
  }

  (0, _createClass3.default)(WishlistButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          active = _props.active;
      // const {active} = this.state;

      return _react3.default.createElement(
        'div',
        { styleName: 'container', onClick: this.handleClick },
        _react3.default.createElement('button', { className: active ? 'wishlist-button-active' : 'wishlist-button', styleName: active ? 'btn-wishlist-on' : 'btn-wishlist' }),
        label ? this.renderLabel() : null
      );
    }
  }]);
  return WishlistButton;
}(_react2.Component), _class2.propTypes = {
  active: _react2.PropTypes.bool,
  label: _react2.PropTypes.bool,
  tripSlug: _react2.PropTypes.string,
  tripId: _react2.PropTypes.string,
  isLoggedIn: _react2.PropTypes.bool,
  openLoginSignup: _react2.PropTypes.func,
  setLoginSignupCallback: _react2.PropTypes.func,
  loadWishlists: _react2.PropTypes.func,
  setWishlistButton: _react2.PropTypes.func,
  addWishlist: _react2.PropTypes.func,
  removeWishlist: _react2.PropTypes.func
}, _class2.defaultProps = {
  active: false,
  label: false
}, _temp)) || _class) || _class));

exports.default = WishlistButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/General/Buttons/WishlistButton.js
// module id = 146
// module chunks = 47